import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=ad410e6e&scoped=true&"
import script from "./product-detail.vue?vue&type=script&lang=js&"
export * from "./product-detail.vue?vue&type=script&lang=js&"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=ad410e6e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad410e6e",
  null
  
)

export default component.exports